export default __webpack_public_path__ + "static/media/login.456a8f3b.svg";